import $ from 'jquery'

function samePageHash(href) {
    if (!href) {
        return null
    }

    if (href.charAt(0) === '#') {
        return href.length > 1 ? href : null
    }

    const hashIndex = href.indexOf('#')
    if (hashIndex === -1) {
        return null
    }

    const hash = href.slice(hashIndex)
    if (hash.length < 2) {
        return null
    }

    try {
        const url = new URL(href, window.location.href)
        const currentPath = window.location.pathname.replace(/\/$/, '')
        const targetPath = url.pathname.replace(/\/$/, '')

        if (url.origin === window.location.origin && targetPath === currentPath) {
            return hash
        }
    } catch (error) { // eslint-disable-line no-unused-vars
        return null
    }

    return null
}

export default () => {
    const $hyperlinks = $('.js-anchor-nav')

    $hyperlinks.click(function (event) {
        const hash = samePageHash($(this).attr('href'))
        if (!hash) {
            return
        }

        const $target = $(hash)
        const offset = $target.offset()
        if (!offset) {
            return
        }

        event.preventDefault()

        let scrollTop = offset.top
        const scrollMarginTop = parseFloat($target.css('scroll-margin-top'))

        if (scrollMarginTop > 0) {
            scrollTop -= scrollMarginTop
        }

        $('html, body').animate({ scrollTop }, 1000)

        if (window.history && window.history.pushState) {
            window.history.pushState(null, '', hash)
        }

        // Close the sidebar menu just in case that's what we clicked.
        $('.js-sidebar').removeClass('is-active');

        $('html, body').removeClass('overflow-hidden')
    })

    const $top = $('.js-scroll-top')

    $top.click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
    })
}